<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center w-100">
          <div class="col">
            <h3 class="page-title">Quản lý Lệnh</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Lệnh</li>
            </ul>
          </div>
          <div class="col-auto d-flex align-items-center">
            <!-- Toggle View -->
            <div class="btn-group mr-2" role="group" aria-label="View switch">
              <button
                class="btn btn-outline-secondary"
                :class="{ active: viewMode==='card' }"
                @click="setView('card')"
                title="Xem dạng thẻ">
                <i class="fa fa-th mr-1"></i> Cards
              </button>
              <button
                class="btn btn-outline-secondary"
                :class="{ active: viewMode==='kanban' }"
                @click="setView('kanban')"
                title="Xem dạng Kanban">
                <i class="fa fa-columns mr-1"></i> Kanban
              </button>
            </div>

            <button class="btn add-btn" @click="openCreate">
              <i class="fa fa-plus"></i> Tạo lệnh
            </button>
          </div>
        </div>
      </div>

      <!-- Bộ lọc -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-md-3">
              <label>Từ ngày</label>
              <input type="date" class="form-control" v-model="filter.from" />
            </div>
            <div class="form-group col-md-3">
              <label>Đến ngày</label>
              <input type="date" class="form-control" v-model="filter.to" />
            </div>
            <div class="form-group col-md-3">
              <label>Loại lệnh</label>
              <select class="form-control" v-model="filter.loai">
                <option value="">Tất cả</option>
                <option value="DIEU_DONG">Điều động</option>
                <option value="TANG_CA">Tăng ca</option>
                <option value="CHU_NHAT">Làm Chủ nhật</option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>Kiểu thưởng</label>
              <select class="form-control" v-model="filter.kieuThuong">
                <option value="">Tất cả</option>
                <option value="HOURLY">Ngoài ca (giờ ca)</option>
                <option value="DAILY">Theo ngày (ca HC)</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Từ khóa</label>
              <input
                type="text"
                class="form-control"
                placeholder="Tiêu đề/Mô tả…"
                v-model.trim="filter.keyword"
                @keyup.enter="fetchOrders"
              />
            </div>
            <div class="form-group col-md-3">
              <label>Trạng thái lệnh</label>
              <select class="form-control" v-model="filter.trangThai">
                <option value="">Tất cả</option>
                <option value="DRAFT">Nháp</option>
                <option value="RUNNING">Đang chạy</option>
                <option value="ENDED">Đã kết thúc</option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>&nbsp;</label>
              <div class="d-flex">
                <button
                  class="btn btn-light flex-fill mr-2"
                  :disabled="loading"
                  @click="resetFilter">
                  <i class="fa fa-eraser mr-1"></i> Xóa lọc
                </button>
                <button
                  class="btn btn-primary flex-fill"
                  :disabled="loading"
                  @click="fetchOrders">
                  <i class="fa fa-search mr-1"></i> Tìm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Thống kê nhanh -->
      <div class="row mb-3">
        <div class="col-md-6 col-lg-3 mb-2">
          <div class="stats-info">
            <h6>Tổng lệnh</h6>
            <h4>{{ stats.total }} <span>theo bộ lọc</span></h4>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-2">
          <div class="stats-info">
            <h6>NV chờ xác nhận</h6>
            <h4>{{ stats.pending }}</h4>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-2">
          <div class="stats-info">
            <h6>NV đã đồng ý</h6>
            <h4>{{ stats.accepted }}</h4>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-2">
          <div class="stats-info">
            <h6>NV từ chối/hết hạn</h6>
            <h4>{{ stats.other }}</h4>
          </div>
        </div>
      </div>

      <!-- ====== VIEW: CARDS GRID ====== -->
      <div class="card" v-if="viewMode==='card'">
        <div class="card-body">
          <div v-if="loading" class="text-center text-muted py-4">Đang tải...</div>

          <div v-else class="row">
            <div class="col-md-6 col-lg-4 mb-3" v-for="it in orders" :key="it.idLenh">
              <div class="order-card card h-100">
                <!-- Header -->
                <div class="card-header d-flex align-items-start justify-content-between">
                  <div class="cursor-pointer" @click="openDetail(it)" :title="it.tieuDe">
                    <div class="order-title">{{ it.tieuDe }}</div>
                    <div class="text-muted small ellipsis-2" :title="it.moTa">{{ it.moTa }}</div>
                  </div>
                  <div class="text-right">
                    <div class="mb-1">
                      <span
                        class="badge mr-1"
                        :class="it.loaiLenh==='DIEU_DONG'?'badge-secondary':(it.loaiLenh==='TANG_CA'?'badge-info':'badge-warning')"
                      >
                        {{ it.loaiLenh==='DIEU_DONG' ? 'Điều động' : (it.loaiLenh==='TANG_CA' ? 'Tăng ca' : 'Chủ nhật') }}
                      </span>
                      <span class="badge" :class="it.kieuThuong==='HOURLY'?'badge-primary':'badge-success'">
                        {{ kieuThuongLabel(it.kieuThuong) }}
                      </span>
                    </div>
                    <span :class="statusBadge(it.trangThai)">{{ labelTrangThai(it.trangThai) }}</span>
                  </div>
                </div>

                <!-- Body -->
                <div class="card-body">
                  <div class="d-flex align-items-start mb-2">
                    <i class="fa fa-play mt-1 mr-2 text-muted"></i>
                    <div>
                      <div class="small text-muted">Bắt đầu</div>
                      <div class="font-weight-600">{{ formatDateTime(it.batDau) }}</div>
                    </div>
                  </div>
                  <div class="d-flex align-items-start mb-2">
                    <i class="fa fa-stop mt-1 mr-2 text-muted"></i>
                    <div>
                      <div class="small text-muted">Kết thúc (ước lượng)</div>
                      <div class="font-weight-600">{{ it.ketThuc ? formatDateTime(it.ketThuc) : '—' }}</div>
                    </div>
                  </div>

                  <div class="d-flex align-items-start mb-2">
                    <i class="fa fa-dollar mt-1 mr-2 text-muted"></i>
                    <div>
                      <div class="small text-muted">Đơn giá</div>
                      <div class="font-weight-600">
                        {{ formatMoney(it.tienCong) }}
                        <span v-if="it.thuongLenhKieu">
                          / {{ hoTroKieuShortLabel(it.thuongLenhKieu) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-1 small text-muted" v-if="it.tinhThuongQuanLy === false">
                    <i class="fa fa-user-times mr-1"></i>Không tính thưởng cho quản lý
                  </div>

                  <div class="mt-3" v-if="it.qlStartAt || it.qlEndAt">
                    <div class="small text-muted mb-1">Thao tác của quản lý</div>
                    <div class="d-flex">
                      <div class="mr-3 small text-muted" v-if="it.qlStartAt">
                        <i class="fa fa-flag mr-1"></i>BĐ:
                        <span class="font-weight-600">{{ formatDateTime(it.qlStartAt) }}</span>
                      </div>
                      <div class="small text-muted" v-if="it.qlEndAt">
                        <i class="fa fa-flag-checkered mr-1"></i>KT:
                        <span class="font-weight-600">{{ formatDateTime(it.qlEndAt) }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3">
                    <div class="small text-muted mb-1">Phân công</div>
                    <div class="d-flex flex-wrap">
                      <span class="pill pill-gray mr-2">Chờ: <b>{{ it.counts?.pending ?? 0 }}</b></span>
                      <span class="pill pill-green mr-2">Đồng ý: <b>{{ it.counts?.accepted ?? 0 }}</b></span>
                      <span class="pill pill-red mr-2">Từ chối: <b>{{ it.counts?.declined ?? 0 }}</b></span>
                      <span class="pill pill-dark">Hết hạn: <b>{{ it.counts?.expired ?? 0 }}</b></span>
                    </div>
                  </div>
                </div>

                <!-- Footer actions -->
                <div class="card-footer bg-white">
                  <div class="d-flex flex-wrap">
                    <button class="btn btn-sm btn-light mr-2 mb-2" @click="openDetail(it)">
                      <i class="fa fa-eye mr-1"></i> Chi tiết
                    </button>
                    <button
                      v-if="canAssign(it)"
                      class="btn btn-sm btn-outline-primary mr-2 mb-2"
                      @click="openAssign(it)"
                    >
                      <i class="fa fa-user-plus mr-1"></i> Gán nhân viên
                    </button>
                    <button
                      v-if="canManagerCheckout(it)"
                      class="btn btn-sm btn-outline-secondary mr-2 mb-2"
                      @click="openManagerCheckout(it)"
                    >
                      <i class="fa fa-sign-out mr-1"></i> Đóng ca (QL)
                    </button>
                    <div class="ml-auto">
                      <button
                        v-if="canStart(it)"
                        class="btn btn-sm btn-success mr-2 mb-2"
                        @click="openStart(it)"
                      >
                        <i class="fa fa-play-circle mr-1"></i> Bắt đầu
                      </button>
                      <button
                        v-if="canEnd(it)"
                        class="btn btn-sm btn-danger mb-2"
                        @click="openEnd(it)"
                      >
                        <i class="fa fa-stop-circle mr-1"></i> Kết thúc
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="orders.length===0" class="col-12">
              <div class="empty-card text-center text-muted py-5">Không có dữ liệu</div>
            </div>
          </div>

          <!-- Phân trang -->
          <div class="d-flex justify-content-between align-items-center mt-3" v-if="page.totalPages>1">
            <div>Trang {{ page.number+1 }}/{{ page.totalPages }}</div>
            <div class="btn-group">
              <button
                class="btn btn-sm btn-outline-secondary"
                :disabled="page.number===0"
                @click="changePage(page.number-1)">‹</button>
              <button
                class="btn btn-sm btn-outline-secondary"
                :disabled="page.number>=page.totalPages-1"
                @click="changePage(page.number+1)">›</button>
            </div>
          </div>
        </div>
      </div>

      <!-- ====== VIEW: KANBAN ====== -->
      <div v-else>
        <div v-if="loading" class="text-center text-muted py-4">Đang tải...</div>

        <div v-else class="kanban-board">
          <div class="kanban-col" v-for="col in kanbanCols" :key="col.key">
            <div class="kanban-col-header" :class="col.headerClass">
              <div class="d-flex align-items-center justify-content-between">
                <div class="font-weight-700">{{ col.title }}</div>
                <span class="badge badge-light">{{ col.items.length }}</span>
              </div>
              <small class="text-white-75">{{ col.subtitle }}</small>
            </div>

            <div class="kanban-col-body">
              <div
                class="kanban-card card"
                v-for="it in col.items"
                :key="it.idLenh"
              >
                <div class="card-body p-3">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="kb-title" @click="openDetail(it)" :title="it.tieuDe">
                        {{ it.tieuDe }}
                      </div>
                      <div class="small text-muted ellipsis-2 mb-2" :title="it.moTa">{{ it.moTa || '—' }}</div>
                    </div>
                    <div class="text-right ml-2">
                      <span
                        class="badge mb-1"
                        :class="it.loaiLenh==='DIEU_DONG'?'badge-secondary':(it.loaiLenh==='TANG_CA'?'badge-info':'badge-warning')">
                        {{ loaiLabel(it.loaiLenh) }}
                      </span>
                      <div>
                        <span class="badge" :class="it.kieuThuong==='HOURLY'?'badge-primary':'badge-success'">
                          {{ kieuThuongShortLabel(it.kieuThuong) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex small text-muted mt-1">
                    <div class="mr-3"><i class="fa fa-play mr-1"></i>{{ formatDateTime(it.batDau) }}</div>
                    <div><i class="fa fa-stop mr-1"></i>{{ it.ketThuc ? formatDateTime(it.ketThuc) : '—' }}</div>
                  </div>

                  <div class="mt-1 small text-muted" v-if="it.tinhThuongQuanLy === false">
                    <i class="fa fa-user-times mr-1"></i>Không tính thưởng QL
                  </div>

                  <!-- Trạng thái vào/ra (quản lý) -->
                  <div class="mt-2" v-if="it.qlStartAt || it.qlEndAt">
                    <div class="small text-muted mb-1">Thao tác của quản lý</div>
                    <div class="d-flex flex-wrap small">
                      <div class="mr-3 text-muted" v-if="it.qlStartAt" :title="it.qlStartDiaDiemText || ''">
                        <i class="fa fa-flag mr-1"></i>BĐ: <b>{{ formatDateTime(it.qlStartAt) }}</b>
                      </div>
                      <div class="text-muted" v-if="it.qlEndAt" :title="it.qlEndDiaDiemText || ''">
                        <i class="fa fa-flag-checkered mr-1"></i>KT: <b>{{ formatDateTime(it.qlEndAt) }}</b>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center justify-content-between mt-2">
                    <div class="kb-pills">
                      <span class="pill pill-gray mr-1">Chờ: <b>{{ it.counts?.pending ?? 0 }}</b></span>
                      <span class="pill pill-green mr-1">OK: <b>{{ it.counts?.accepted ?? 0 }}</b></span>
                      <span class="pill pill-red mr-1">Từ chối: <b>{{ it.counts?.declined ?? 0 }}</b></span>
                      <span class="pill pill-dark">Hết hạn: <b>{{ it.counts?.expired ?? 0 }}</b></span>
                    </div>
                    <div class="kb-actions">
                      <button v-if="canStart(it)" class="btn btn-xs btn-outline-success mr-1" @click="openStart(it)">
                        <i class="fa fa-play"></i>
                      </button>
                      <button v-if="canEnd(it)" class="btn btn-xs btn-outline-danger mr-1" @click="openEnd(it)">
                        <i class="fa fa-stop"></i>
                      </button>
                      <button v-if="canAssign(it)" class="btn btn-xs btn-outline-primary mr-1" @click="openAssign(it)">
                        <i class="fa fa-user-plus"></i>
                      </button>
                      <button
                        v-if="canManagerCheckout(it)"
                        class="btn btn-xs btn-outline-secondary"
                        @click="openManagerCheckout(it)">
                        <i class="fa fa-sign-out"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="col.items.length===0" class="kb-empty text-muted">Không có lệnh</div>
            </div>
          </div>
        </div>

        <!-- Kanban không phân trang (tải nhiều hơn) -->
        <div class="text-center mt-3" v-if="page.totalPages>1">
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="loading || page.number>=page.totalPages-1"
            @click="loadMoreKanban">
            Tải thêm
          </button>
        </div>
      </div>
    </div>

    <!-- ========== Modals ========== -->
    <!-- Modal: Tạo lệnh -->
    <div id="modalCreate" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Tạo lệnh</h5>
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-md-8">
                <label>Tiêu đề <span class="text-danger">*</span></label>
                <input class="form-control" v-model.trim="createForm.tieuDe" placeholder="VD: Tăng ca ca tối 17–21h" />
              </div>
              <div class="form-group col-md-4">
                <label>Loại lệnh <span class="text-danger">*</span></label>
                <select class="form-control" v-model="createForm.loai" @change="onLoaiChange">
                  <option disabled value="">-- Chọn loại --</option>
                  <option value="DIEU_DONG">Điều động</option>
                  <option value="TANG_CA">Tăng ca</option>
                  <option value="CHU_NHAT">Làm Chủ nhật</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label>Mô tả</label>
              <textarea class="form-control" rows="3" v-model.trim="createForm.moTa" placeholder="Ghi chú thêm (địa điểm, yêu cầu…)"></textarea>
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Kiểu thưởng <span class="text-danger">*</span></label>
                <select
                  class="form-control"
                  v-model="createForm.kieuThuong"
                  :disabled="['TANG_CA','CHU_NHAT','DIEU_DONG'].includes(createForm.loai)"
                >
                  <option disabled value="">-- Chọn kiểu thưởng --</option>
                  <option value="HOURLY">Ngoài ca (giờ ca)</option>
                  <option value="DAILY">Theo ngày (ca HC)</option>
                </select>
                <small class="text-muted" v-if="createForm.loai==='TANG_CA'">
                  Tăng ca: thưởng theo các ca Ngoài ca (giờ ca).
                </small>
                <small class="text-muted" v-else-if="createForm.loai==='CHU_NHAT'">
                  Chủ nhật: thưởng theo công ngày từ ca làm việc của NV.
                </small>
                <small class="text-muted" v-else-if="createForm.loai==='DIEU_DONG'">
                  Điều động: thưởng theo ngày, backend tính trên ca HC/ngoài ca của NV.
                </small>
                <small class="text-muted" v-else>
                  Chọn cách tính thưởng cho lệnh.
                </small>
              </div>
              <div class="form-group col-md-4">
                <label>Đơn giá <span class="text-danger" v-if="createForm.loai!=='DIEU_DONG'">*</span></label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  step="1000"
                  v-model.number="createForm.tienCong"
                  :placeholder="createForm.loai==='DIEU_DONG' ? 'Có thể để 0' : 'VD: 50.000'"
                />
                <select
                  class="form-control mt-1"
                  v-model="createForm.thuongLenhKieu"
                >
                  <option
                    v-for="opt in hoTroKieuOptions"
                    :key="'thuong-'+opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small class="text-muted d-block mt-1" v-if="createForm.kieuThuong==='HOURLY'">
                  đ/giờ (thông tin tham khảo, đơn giá chính lấy từ ca Ngoài ca).
                </small>
                <small class="text-muted d-block" v-else-if="createForm.kieuThuong==='DAILY'">
                  đ/ngày (1.0 công, dùng như phụ cấp lệnh nếu cần).
                </small>
                <small class="text-muted d-block" v-if="createForm.loai==='DIEU_DONG'">
                  Điều động: có thể để đơn giá = 0 và chỉ dùng hỗ trợ xăng xe/cơm.
                </small>
              </div>
              <div class="form-group col-md-4">
                <label>Thưởng cho quản lý</label>
                <div class="custom-control custom-switch mt-2">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switchManagerReward"
                    v-model="createForm.tinhThuongQuanLy"
                  />
                  <label class="custom-control-label" for="switchManagerReward">
                    {{ createForm.tinhThuongQuanLy ? 'Có tính thưởng' : 'Không tính thưởng' }}
                  </label>
                </div>
                <small class="text-muted">Áp dụng cho người tạo lệnh.</small>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Bắt đầu <span class="text-danger">*</span></label>
                <input type="datetime-local" class="form-control" v-model="createForm.batDau" />
              </div>
              <div class="form-group col-md-4">
                <label>Kết thúc <span class="text-danger" v-if="createForm.kieuThuong==='HOURLY' && createForm.loai!=='DIEU_DONG'">*</span></label>
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="createForm.ketThuc"
                  :placeholder="createForm.kieuThuong==='DAILY' || createForm.loai==='DIEU_DONG' ? 'Không bắt buộc' : ''"
                />
                <small class="text-muted" v-if="createForm.kieuThuong==='DAILY' || createForm.loai==='DIEU_DONG'">
                  Theo ngày/Điều động: có thể bỏ trống (backend tự quy định khung).
                </small>
              </div>
            </div>

            <!-- Hỗ trợ riêng cho Điều động -->
            <div class="form-row" v-if="createForm.loai==='DIEU_DONG'">
              <div class="form-group col-md-4">
                <label>Hỗ trợ xăng xe</label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  step="1000"
                  v-model.number="createForm.hoTroXangXe"
                  placeholder="VD: 30.000"
                />
                <select
                  class="form-control mt-1"
                  v-model="createForm.hoTroXangKieu"
                >
                  <option
                    v-for="opt in hoTroKieuOptions"
                    :key="'xang-'+opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small class="text-muted d-block mt-1">
                  Áp dụng cho
                  {{ createForm.hoTroXangKieu === 'PER_DAY' ? 'mỗi ngày làm trong lệnh' : 'cả lệnh (1 lần)' }}.
                </small>
              </div>
              <div class="form-group col-md-4">
                <label>Hỗ trợ cơm</label>
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  step="1000"
                  v-model.number="createForm.hoTroCom"
                  placeholder="VD: 25.000"
                />
                <select
                  class="form-control mt-1"
                  v-model="createForm.hoTroComKieu"
                >
                  <option
                    v-for="opt in hoTroKieuOptions"
                    :key="'com-'+opt.value"
                    :value="opt.value"
                  >
                    {{ opt.label }}
                  </option>
                </select>
                <small class="text-muted d-block mt-1">
                  Áp dụng cho
                  {{ createForm.hoTroComKieu === 'PER_DAY' ? 'mỗi ngày làm trong lệnh' : 'cả lệnh (1 lần)' }}.
                </small>
              </div>
            </div>

            <hr />

            <!-- Chọn nhân viên -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Chọn nhân viên (tuỳ chọn)</label>
                <multiselect
                  v-model="createForm.selectedUsers"
                  :options="usersForCreate"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :searchable="true"
                  track-by="idNguoiDung"
                  label="__label"
                  placeholder="Gõ để tìm & chọn nhiều…"
                >
                  <template #option="{ option }">
                    <div class="d-flex align-items-center">
                      <div class="font-weight-600 mr-2">{{ option.hoTen || option.tenDangNhap }}</div>
                      <small class="text-muted">#{{ option.idNguoiDung }} — {{ option.tenPhongBan || '—' }}</small>
                    </div>
                  </template>
                  <template #tag="{ option, remove }">
                    <span class="custom-tag">
                      {{ option.hoTen || option.tenDangNhap }}
                      <i class="fa fa-times" @click="remove(option)"></i>
                    </span>
                  </template>
                </multiselect>
                <small class="text-muted d-block mt-1">
                  Nếu bạn chọn nhân viên tại đây, hệ thống sẽ <b>tự động gán</b> vào lệnh ngay sau khi tạo.
                </small>
              </div>
            </div>

            <!-- Chọn phòng ban để tự động gán toàn bộ NV -->
            <div class="form-row mt-2">
              <div class="form-group col-md-12">
                <label>Chọn phòng ban (tự động gán toàn bộ NV)</label>
                <multiselect
                  v-model="createForm.selectedPhongBans"
                  :options="phongBans"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :searchable="true"
                  track-by="idPhongBan"
                  label="__label"
                  placeholder="Gõ để tìm & chọn nhiều phòng ban…"
                >
                  <template #option="{ option }">
                    <div class="d-flex align-items-center">
                      <div class="font-weight-600 mr-2">{{ option.tenPhongBan }}</div>
                      <small class="text-muted" v-if="option.maPhongBan">
                        Mã: {{ option.maPhongBan }}
                      </small>
                    </div>
                  </template>
                  <template #tag="{ option, remove }">
                    <span class="custom-tag">
                      {{ option.tenPhongBan }}
                      <i class="fa fa-times" @click="remove(option)"></i>
                    </span>
                  </template>
                </multiselect>
                <small class="text-muted d-block mt-1">
                  Sau khi tạo lệnh, hệ thống sẽ tự động gán <b>tất cả nhân viên đang hoạt động</b>
                  trong các phòng ban này vào lệnh.
                </small>
              </div>
            </div>

            <div class="alert alert-info">
              - <b>Ca Hành chính (HC)</b>: dùng để tính <b>công ngày</b> (0 / 0.5 / 1.0) tuỳ số ca HC hoàn thành.<br />
              - <b>Ca Ngoài ca (Lệnh)</b>: dùng để tính <b>tiền thưởng</b> theo <b>đơn giá ca</b> (đ/giờ) hoặc <b>FLAT</b> theo cấu hình ca.<br />
              - <b>Tăng ca</b>: hệ thống tự tính số giờ thưởng = tổng thời lượng lệnh chồng lên các ca Ngoài ca của NV.<br />
              - <b>Lệnh Chủ nhật / Điều động</b>: công/tiền được backend tính dựa trên ca của NV trong ngày đó (HC hoặc Ngoài ca).<br />
              - NV đi <b>trễ</b>: vẫn tính từ giờ vào thực tế, phần bị trễ có thể bị <b>trừ thưởng</b> theo quy tắc backend.<br />
              - NV chỉ được chấm công lệnh khi đã <b>đồng ý</b> tham gia lệnh.
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" :disabled="creating" @click="submitCreate">Tạo lệnh</button>
            <button class="btn btn-outline-secondary" data-dismiss="modal">Đóng</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== Modal Camera Fullscreen (BẮT ĐẦU) ===== -->
    <div v-if="camera.open && camera.for === 'start'" ref="cameraModalRef" class="camera-modal camera-modal--fs">
      <div class="camera-box camera-box--fs">
        <!-- Top bar -->
        <div class="camera-header camera-header--fs">
          <div class="d-flex align-items-center text-white">
            <b>Chụp ảnh để bắt đầu lệnh</b>
            <span class="small text-white-50 ml-2" v-if="camera.deviceLabel">({{ camera.deviceLabel }})</span>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn btn-sm btn-outline-light mr-2"
                    @click="switchCamera"
                    :disabled="camera.loading || camera.step!=='live'">
              <i class="fa fa-retweet"></i> Đổi camera
            </button>
            <button class="btn btn-sm btn-outline-light" @click="closeCamera">Đóng</button>
          </div>
        </div>

        <!-- LIVE -->
        <div v-if="camera.step==='live'">
          <video ref="videoRef" autoplay playsinline muted class="camera-video camera-video--fs"></video>

          <!-- Bottom bar (live) -->
          <div class="camera-actions camera-actions--fs">
            <button class="btn btn-success btn-lg btn-cta btn-cta-fs w-100"
                    :disabled="starting || camera.loading"
                    @click="capture()">
              <i class="fa fa-camera mr-1"></i> Chụp
            </button>

            <div class="small text-white-50 mt-2 text-center" v-if="!camera.geo.ready">
              Đang lấy vị trí…
            </div>
            <div class="small text-white-50 mt-1 text-center" v-else-if="camera.geo.lat!=null">
              {{ camera.geo.address || (camera.geo.lat.toFixed(6)+', '+camera.geo.lng.toFixed(6)) }}
            </div>
          </div>
        </div>

        <!-- CONFIRM -->
        <div v-else class="confirm-pane">
          <img :src="camera.previewUrl" class="confirm-img confirm-img--fs" alt="preview"/>

          <!-- Bottom bar (confirm) -->
          <div class="camera-actions camera-actions--fs">
            <div class="d-flex w-100">
              <button class="btn btn-outline-light btn-lg btn-cta btn-cta-fs w-50 mr-2"
                      :disabled="starting || camera.loading"
                      @click="retake()">
                <i class="fa fa-refresh mr-1"></i> Chụp lại
              </button>
              <button class="btn btn-success btn-lg btn-cta btn-cta-fs w-50"
                      :disabled="starting || camera.loading"
                      @click="submitStart()">
                <i class="fa fa-send mr-1"></i> Bắt đầu lệnh
              </button>
            </div>
          </div>
        </div>

        <canvas ref="canvasRef" class="d-none"></canvas>
      </div>
    </div>

    <!-- ===== Modal Camera Fullscreen (KẾT THÚC) ===== -->
    <div v-if="camera.open && camera.for === 'end'" ref="cameraModalRef" class="camera-modal camera-modal--fs">
      <div class="camera-box camera-box--fs">
        <!-- Top bar -->
        <div class="camera-header camera-header--fs">
          <div class="d-flex align-items-center text-white">
            <b>Chụp ảnh để kết thúc lệnh</b>
            <span class="small text-white-50 ml-2" v-if="camera.deviceLabel">({{ camera.deviceLabel }})</span>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn btn-sm btn-outline-light mr-2"
                    @click="switchCamera"
                    :disabled="camera.loading || camera.step!=='live'">
              <i class="fa fa-retweet"></i> Đổi camera
            </button>
            <button class="btn btn-sm btn-outline-light" @click="closeCamera">Đóng</button>
          </div>
        </div>

        <!-- LIVE -->
        <div v-if="camera.step==='live'">
          <video ref="videoRef" autoplay playsinline muted class="camera-video camera-video--fs"></video>

          <!-- Bottom bar (live) -->
          <div class="camera-actions camera-actions--fs">
            <button class="btn btn-success btn-lg btn-cta btn-cta-fs w-100"
                    :disabled="ending || camera.loading"
                    @click="capture()">
              <i class="fa fa-camera mr-1"></i> Chụp
            </button>

            <div class="small text-white-50 mt-2 text-center" v-if="!camera.geo.ready">
              Đang lấy vị trí…
            </div>
            <div class="small text-white-50 mt-1 text-center" v-else-if="camera.geo.lat!=null">
              {{ camera.geo.address || (camera.geo.lat.toFixed(6)+', '+camera.geo.lng.toFixed(6)) }}
            </div>
          </div>
        </div>

        <!-- CONFIRM -->
        <div v-else class="confirm-pane">
          <img :src="camera.previewUrl" class="confirm-img confirm-img--fs" alt="preview"/>

          <!-- Bottom bar (confirm) -->
          <div class="camera-actions camera-actions--fs">
            <div class="d-flex w-100">
              <button class="btn btn-outline-light btn-lg btn-cta btn-cta-fs w-50 mr-2"
                      :disabled="ending || camera.loading"
                      @click="retake()">
                <i class="fa fa-refresh mr-1"></i> Chụp lại
              </button>
              <button class="btn btn-danger btn-lg btn-cta btn-cta-fs w-50"
                      :disabled="ending || camera.loading"
                      @click="submitEnd()">
                <i class="fa fa-send mr-1"></i> Kết thúc lệnh
              </button>
            </div>
          </div>
        </div>

        <canvas ref="canvasRef" class="d-none"></canvas>
      </div>
    </div>

    <!-- Modal: Gán NV -->
    <div id="modalAssign" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Gán nhân viên — {{ assignCtx.order?.tieuDe || '' }}</h5>
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Phòng ban</label>
                <select class="form-control" v-model="assignFilter.phongBanId" @change="loadUsers">
                  <option :value="null">Tất cả</option>
                  <option
                    v-for="pb in phongBans"
                    :key="pb.idPhongBan || pb.id"
                    :value="pb.idPhongBan || pb.id"
                  >
                    {{ pb.tenPhongBan }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-12">
                <label>Chọn nhân viên</label>
                <multiselect
                  v-model="assignCtx.selectedUsers"
                  :options="users"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :searchable="true"
                  track-by="idNguoiDung"
                  label="__label"
                  placeholder="Gõ để tìm & chọn nhiều…"
                >
                  <template #option="{ option }">
                    <div class="d-flex align-items-center">
                      <div class="font-weight-600 mr-2">{{ option.hoTen || option.tenDangNhap }}</div>
                      <small class="text-muted">#{{ option.idNguoiDung }} — {{ option.tenPhongBan || '—' }}</small>
                    </div>
                  </template>
                  <template #tag="{ option, remove }">
                    <span class="custom-tag">
                      {{ option.hoTen || option.tenDangNhap }}
                      <i class="fa fa-times" @click="remove(option)"></i>
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-outline-primary mr-auto"
              v-if="assignCtx.order && assignFilter.phongBanId"
              :disabled="assigningDept"
              @click="submitAssignDept"
            >
              Gán cả phòng ban này
            </button>
            <button
              class="btn btn-primary"
              :disabled="assigning || (assignCtx.selectedUsers||[]).length===0"
              @click="submitAssign"
            >
              Gán {{ (assignCtx.selectedUsers||[]).length }} nhân viên
            </button>
            <button class="btn btn-outline-secondary" data-dismiss="modal">Đóng</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Đóng ca (Quản lý) -->
    <div id="modalManagerCheckout" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Đóng ca (QL) — {{ mCheckout.order?.tieuDe || '' }}</h5>
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="text-muted mb-2">
              Chọn nhân viên (đã đồng ý & đã check-in, chưa check-out) để đóng ca ngay bây giờ.
            </div>

            <multiselect
              v-model="mCheckout.selectedUsers"
              :options="mCheckout.options"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :searchable="true"
              track-by="idNguoiDung"
              label="__label"
              placeholder="Gõ để tìm & chọn…"
            >
              <template #option="{ option }">
                <div class="d-flex align-items-center">
                  <div class="font-weight-600 mr-2">{{ option.hoTen || option.tenDangNhap }}</div>
                  <small class="text-muted">#{{ option.idNguoiDung }} — {{ option.tenPhongBan || '—' }}</small>
                </div>
              </template>
              <template #noResult>
                <small class="text-muted">Không còn nhân viên nào cần đóng ca.</small>
              </template>
            </multiselect>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" :disabled="managerClosing || (mCheckout.selectedUsers||[]).length===0" @click="submitManagerCheckout">
              Đóng ca {{ (mCheckout.selectedUsers||[]).length }} NV
            </button>
            <button class="btn btn-outline-secondary" data-dismiss="modal">Đóng</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Chi tiết lệnh -->
    <div id="modalDetail" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h5 class="modal-title">Chi tiết lệnh — {{ detail.data?.lenh?.tieuDe || '' }}</h5>
              <div class="small text-muted">{{ detail.data?.lenh?.moTa }}</div>
            </div>
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
          </div>

          <div class="modal-body" v-if="detail.loading">Đang tải…</div>

          <div class="modal-body" v-else>
            <div class="row">
              <!-- Info + Start/End images -->
              <div class="col-lg-7">
                <div class="card mb-3">
                  <div class="card-header"><b>Thông tin lệnh</b></div>
                  <div class="card-body small">
                    <div class="row">
                      <div class="col-md-6 mb-2"><b>Loại:</b> {{ detail.data?.lenh?.loaiLenh }}</div>
                      <div class="col-md-6 mb-2"><b>Kiểu thưởng:</b> {{ kieuThuongLabel(detail.data?.lenh?.kieuThuong) }}</div>
                      <div class="col-md-6 mb-2"><b>Bắt đầu:</b> {{ formatDateTime(detail.data?.lenh?.batDau) }}</div>
                      <div class="col-md-6 mb-2"><b>Kết thúc (ước lượng):</b> {{ detail.data?.lenh?.ketThuc ? formatDateTime(detail.data?.lenh?.ketThuc) : '—' }}</div>
                      <div class="col-md-6 mb-2">
                        <b>Đơn giá:</b>
                        {{ formatMoney(detail.data?.lenh?.tienCong) }}
                        <span v-if="detail.data?.lenh?.thuongLenhKieu">
                          / {{ hoTroKieuLabel(detail.data.lenh.thuongLenhKieu) }}
                        </span>
                      </div>
                      <div class="col-md-6 mb-2">
                        <b>Trạng thái:</b>
                        <span :class="statusBadge(detail.data?.lenh?.trangThai)">{{ labelTrangThai(detail.data?.lenh?.trangThai) }}</span>
                      </div>
                      <div class="col-md-6 mb-2">
                        <b>Thưởng QL:</b>
                        {{ detail.data?.lenh?.tinhThuongQuanLy ? 'Có' : 'Không' }}
                      </div>
                      <div class="col-md-6 mb-2" v-if="detail.data?.lenh?.loaiLenh==='DIEU_DONG'">
                        <b>HT xăng xe:</b>
                        {{ formatMoney(detail.data?.lenh?.hoTroXangXe || 0) }}
                        <span v-if="detail.data?.lenh?.hoTroXangKieu">
                          / {{ hoTroKieuLabel(detail.data.lenh.hoTroXangKieu) }}
                        </span>
                      </div>
                      <div class="col-md-6 mb-2" v-if="detail.data?.lenh?.loaiLenh==='DIEU_DONG'">
                        <b>HT cơm:</b>
                        {{ formatMoney(detail.data?.lenh?.hoTroCom || 0) }}
                        <span v-if="detail.data?.lenh?.hoTroComKieu">
                          / {{ hoTroKieuLabel(detail.data.lenh.hoTroComKieu) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card mb-3">
                  <div class="card-header"><b>Ảnh & vị trí lệnh</b></div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <div class="small text-muted mb-1">Bắt đầu</div>
                        <div class="thumb" v-if="detail.data?.lenh?.qlStartAnhUrl" @click="openLightbox([detail.data.lenh.qlStartAnhUrl],0)">
                          <img :src="detail.data?.lenh?.qlStartAnhUrl" alt="Ảnh bắt đầu" />
                        </div>
                        <div class="text-muted small" v-else>—</div>
                        <div class="mt-2 small">
                          <div><b>Thời gian:</b> {{ detail.data?.lenh?.qlStartAt ? formatDateTime(detail.data.lenh.qlStartAt) : '—' }}</div>
                          <div><b>Vị trí:</b> {{ detail.data?.lenh?.qlStartDiaDiemText || '—' }}</div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="small text-muted mb-1">Kết thúc</div>
                        <div class="thumb" v-if="detail.data?.lenh?.qlEndAnhUrl" @click="openLightbox([detail.data.lenh.qlEndAnhUrl],0)">
                          <img :src="detail.data?.lenh?.qlEndAnhUrl" alt="Ảnh kết thúc" />
                        </div>
                        <div class="text-muted small" v-else>—</div>
                        <div class="mt-2 small">
                          <div><b>Thời gian:</b> {{ detail.data?.lenh?.qlEndAt ? formatDateTime(detail.data.lenh.qlEndAt) : '—' }}</div>
                          <div><b>Vị trí:</b> {{ detail.data?.lenh?.qlEndDiaDiemText || '—' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Assignments + Chấm công (cards) -->
              <div class="col-lg-5">
                <div class="card mb-3">
                  <div class="card-header"><b>Phân công</b></div>
                  <div class="card-body" style="max-height: 35vh; overflow:auto">
                    <div v-for="a in detail.data?.assignments || []" :key="a.userId" class="assign-card">
                      <div class="d-flex justify-content-between">
                        <div class="font-weight-600">{{ a.hoTen || ('#'+a.userId) }}</div>
                        <span class="badge" :class="assignBadge(a.status)">{{ a.status }}</span>
                      </div>
                      <div class="text-muted small">{{ a.tenPhongBan || '—' }}</div>
                    </div>
                    <div v-if="(detail.data?.assignments||[]).length===0" class="text-center text-muted">Không có phân công</div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header"><b>Chấm công lệnh</b></div>
                  <div class="card-body" style="max-height: 35vh; overflow:auto">
                    <div v-for="c in detail.data?.chamCongList || []" :key="c.userId" class="cc-card">
                      <div class="d-flex justify-content-between mb-1">
                        <div class="font-weight-600">{{ c.hoTen || ('#'+c.userId) }}</div>
                        <div>
                          <span class="badge badge-light mr-1">{{ c.vaoTrangThai || '—' }}</span>
                          <span class="badge" :class="raBadge(c.raTrangThai)">{{ c.raTrangThai || '—' }}</span>
                        </div>
                      </div>

                      <div class="row small">
                        <div class="col-6">
                          <div class="text-muted">Vào</div>
                          <div>{{ c.gioVao ? formatDateTime(c.gioVao) : '—' }}</div>
                          <div v-if="c.anhVaoUrl" class="thumb xs mt-1" @click="openLightbox([c.anhVaoUrl],0)">
                            <img :src="c.anhVaoUrl" alt="Ảnh vào" />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="text-muted">Ra</div>
                          <div>{{ c.gioRa ? formatDateTime(c.gioRa) : '—' }}</div>
                          <div v-if="c.anhRaUrl" class="thumb xs mt-1" @click="openLightbox([c.anhRaUrl],0)">
                            <img :src="c.anhRaUrl" alt="Ảnh ra" />
                          </div>
                        </div>
                      </div>

                      <div class="row small mt-2">
                        <div class="col-6"><b>Bắt đầu tính:</b> {{ c.effectiveStart ? formatDateTime(c.effectiveStart) : '—' }}</div>
                        <div class="col-6 text-right">
                          <b>Đóng ca bởi:</b>
                          <span class="badge" :class="c.checkoutBy==='MANAGER'?'badge-dark':'badge-info'">{{ c.checkoutBy || '—' }}</span>
                        </div>
                      </div>

                      <div class="row small mt-1">
                        <div class="col-6">
                          <b>Giờ/Công:</b>
                          <span v-if="c.soGioThuong && Number(c.soGioThuong)>0">{{ c.soGioThuong }} h</span>
                          <span v-else>{{ c.soCongThuong || 0 }} công</span>
                        </div>
                        <div class="col-6 text-right"><b>Tiền:</b> {{ formatMoney(c.soTienThuong) }}</div>
                      </div>
                    </div>

                    <div v-if="(detail.data?.chamCongList||[]).length===0" class="text-center text-muted">Chưa có chấm công</div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-outline-secondary" data-dismiss="modal">Đóng</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Lightbox xem ảnh -->
    <vue-easy-lightbox
      :visible="lightbox.visible"
      :imgs="lightbox.images"
      :index="lightbox.index"
      @hide="lightbox.visible=false"
    />
  </div>
</template>

<script>
import api from "@/api";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";

const STORAGE_KEY_VIEW = "lenh_view_mode";
const GEOAPIFY_KEY = "2209ae8943f74a18b5d0d7676d65cd50";
const WM_LOGO_URL = "/assets/img/profiles/logominhtien.png";

// Format LOCAL yyyy-mm-dd (tránh lệch múi giờ khi bind <input type="date">)
const toYMDLocal = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export default {
  name: "LenhManager",
  components: { Multiselect, VueEasyLightbox },
  data() {
    const today = new Date();
    const from = toYMDLocal(new Date(today.getFullYear(), today.getMonth(), 1));
    const to   = toYMDLocal(today);

    const savedView = localStorage.getItem(STORAGE_KEY_VIEW);
    const isMobile = window.matchMedia && window.matchMedia("(max-width: 991px)").matches;
    const initialView = savedView || (isMobile ? "card" : "kanban");

    return {
      viewMode: initialView,
      loading: false,
      creating: false,
      assigning: false,
      assigningDept: false,
      managerClosing: false,
      starting: false,
      ending: false,

      orders: [],
      stats: { total: 0, pending: 0, accepted: 0, other: 0 },
      page: { number: 0, size: initialView === "kanban" ? 30 : 9, totalPages: 1 },

      filter: { from, to, loai: "", kieuThuong: "", trangThai: "", keyword: "" },

      // Create
      createForm: {
        tieuDe: "",
        moTa: "",
        loai: "",
        kieuThuong: "",
        batDau: "",
        ketThuc: "",
        tienCong: null,
        tinhThuongQuanLy: true,
        hoTroXangXe: null,
        hoTroCom: null,
        hoTroXangKieu: "PER_DAY",
        hoTroComKieu: "PER_DAY",
        thuongLenhKieu: "PER_DAY",
        selectedUsers: [],
        selectedPhongBans: [],
      },
      createFilter: { phongBanId: null },
      usersForCreate: [],
      hoTroKieuOptions: [
        { value: "PER_DAY", label: "Theo ngày làm thực tế" },
        { value: "PER_ORDER", label: "Theo lệnh (1 lần)" },
      ],

      // Assign
      assignCtx: { order: null, selectedUsers: [] },
      assignFilter: { phongBanId: null },
      users: [],
      phongBans: [],

      // Manager checkout
      mCheckout: { order: null, options: [], selectedUsers: [] },

      // Camera
      camera: {
        open: false,
        stream: null,
        for: null,      // 'start' | 'end'
        order: null,
        loading: false,
        devices: [],
        deviceIndex: 0,
        lastFacing: 'environment',
        deviceLabel: '',
        geo: { ready:false, lat:null, lng:null, address:'' },
        step: 'live',        // 'live' | 'confirm'
        previewUrl: null,    // objectURL
        blob: null,          // Blob
        captured: false
      },

      // Detail
      detail: { loading: false, data: null },

      // Lightbox
      lightbox: { visible: false, images: [], index: 0 },

      // Watermark logo cache
      _wmLogo: null,
    };
  },
  computed: {
    kanbanCols() {
      const cols = [
        { key: "DRAFT",   title: "Nháp",        headerClass: "kb-hd-draft",   subtitle: "Lệnh chưa chạy", items: [] },
        { key: "RUNNING", title: "Đang chạy",   headerClass: "kb-hd-running", subtitle: "Đang thực thi",  items: [] },
        { key: "ENDED",   title: "Đã kết thúc", headerClass: "kb-hd-ended",   subtitle: "Đã đóng ca",     items: [] },
      ];
      for (const it of this.orders) {
        const col = cols.find((c) => c.key === (it.trangThai || "DRAFT"));
        (col ? col.items : cols[0].items).push(it);
      }
      return cols;
    },
  },
  mounted() {
    this.fetchPhongBan();
    this.fetchOrders();

    // Preload watermark logo
    const img = new Image();
    img.onload = () => (this._wmLogo = img);
    img.src = WM_LOGO_URL;
  },
  beforeUnmount() {
    this.stopCamera();
  },
  methods: {
    setView(mode) {
      if (this.viewMode === mode) return;
      this.viewMode = mode;
      localStorage.setItem(STORAGE_KEY_VIEW, mode);
      this.page.size = mode === "kanban" ? Math.max(this.page.size, 30) : 9;
      this.page.number = 0;
      this.fetchOrders();
    },

    resetFilter() {
      const today = new Date();
      const from = toYMDLocal(new Date(today.getFullYear(), today.getMonth(), 1));
      const to   = toYMDLocal(today);
      this.filter = { from, to, loai: "", kieuThuong: "", trangThai: "", keyword: "" };
      this.page.number = 0;
      this.fetchOrders();
    },

    /* ---------- Helpers ---------- */
    loaiLabel(v) {
      return v === "DIEU_DONG" ? "Điều động" : v === "TANG_CA" ? "Tăng ca" : v === "CHU_NHAT" ? "Chủ nhật" : v;
    },
    kieuThuongLabel(v) {
      if (v === "HOURLY") return "Ngoài ca (giờ ca)";
      if (v === "DAILY") return "Theo ngày (ca HC)";
      return v || "";
    },
    kieuThuongShortLabel(v) {
      if (v === "HOURLY") return "Ngoài ca";
      if (v === "DAILY") return "Theo ngày";
      return v || "";
    },
    hoTroKieuLabel(v) {
      if (v === "PER_DAY") return "Theo ngày làm thực tế";
      if (v === "PER_ORDER") return "Theo lệnh (1 lần)";
      return v || "";
    },
    hoTroKieuShortLabel(v) {
      if (v === "PER_DAY") return "ngày";
      if (v === "PER_ORDER") return "lệnh";
      return v || "";
    },
    formatDateTime(dt) {
      return dt ? new Date(dt).toLocaleString("vi-VN", { hour12: false }) : "";
    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString("vi-VN") + " đ";
    },
    labelTrangThai(st) {
      return st === "DRAFT"
        ? "Nháp"
        : st === "RUNNING"
        ? "Đang chạy"
        : st === "ENDED"
        ? "Đã kết thúc"
        : st || "";
    },
    statusBadge(st) {
      if (st === "DRAFT") return "badge badge-secondary";
      if (st === "RUNNING") return "badge badge-info";
      if (st === "ENDED") return "badge badge-success";
      return "badge badge-light";
    },
    assignBadge(st) {
      if (st === "PENDING") return "badge-secondary";
      if (st === "ACCEPTED") return "badge-success";
      if (st === "DECLINED") return "badge-danger";
      if (st === "EXPIRED") return "badge-dark";
      return "badge-light";
    },
    raBadge(st) {
      if (st === "DUNG_GIO") return "badge-success";
      if (st === "RA_SOM") return "badge-warning";
      if (st === "QUA_GIO") return "badge-danger";
      return "badge-light";
    },
    openLightbox(imgs, index = 0) {
      this.lightbox.images = imgs;
      this.lightbox.index = index;
      this.lightbox.visible = true;
    },

    /* ---------- Quy tắc hiển thị nút ---------- */
    canAssign(order)  { return order.trangThai === "DRAFT"; },
    canStart(order)   { return order.trangThai === "DRAFT"; },
    canEnd(order)     { return order.trangThai === "RUNNING"; },
    canManagerCheckout(order) {
      return order.trangThai === "RUNNING" && (order.counts?.accepted ?? 0) > 0;
    },

    /* ---------- Chuẩn hoá bản ghi để luôn có idLenh ---------- */
    normalizeOrder(o) {
      const idLenh = o.idLenh ?? o.id ?? o.lenhId ?? (o.lenh?.idLenh ?? null);
      return { idLenh, ...o };
    },

    /* ---------- List ---------- */
    async fetchOrders() {
      this.loading = true;
      try {
        const params = {
          from: this.filter.from || null,
          to: this.filter.to || null,
          loai: this.filter.loai || null,
          kieuThuong: this.filter.kieuThuong || null,
          trangThai: this.filter.trangThai || null,
          keyword: this.filter.keyword || null,
          page: this.page.number,
          size: this.page.size,
        };
        // Nếu BE dùng /api/lenh cho admin, đổi endpoint tại đây cho phù hợp
        const { data } = await api.get("/api/lenh/admin/list", { params });
        const body = data?.data || {};
        const items = body.content || body.items || [];
        const normalized = items.map(this.normalizeOrder);
        this.orders = normalized;
        this.page.totalPages = body.totalPages || 1;
        this.page.number = body.number || 0;

        let total = body.totalElements ?? normalized.length;
        let pending = 0, accepted = 0, declined = 0, expired = 0;
        normalized.forEach((o) => {
          pending  += o.counts?.pending  ?? 0;
          accepted += o.counts?.accepted ?? 0;
          declined += o.counts?.declined ?? 0;
          expired  += o.counts?.expired  ?? 0;
        });

        let stats = { total, pending, accepted, other: declined + expired };

        if (body.stats) {
          const s = body.stats;
          stats = {
            total: s.totalOrders ?? s.total ?? stats.total,
            pending: s.pendingUsers ?? s.pending ?? stats.pending,
            accepted: s.acceptedUsers ?? s.accepted ?? stats.accepted,
            other:
              s.otherUsers ??
              s.other ??
              s.declinedUsers ??
              (s.expiredUsers != null ? (s.declinedUsers || 0) + s.expiredUsers : stats.other),
          };
        }

        this.stats = stats;
      } catch (e) {
        console.error(e);
        this.orders = [];
        this.stats = { total: 0, pending: 0, accepted: 0, other: 0 };
      } finally {
        this.loading = false;
      }
    },
    changePage(p) {
      this.page.number = Math.max(0, Math.min(p, this.page.totalPages - 1));
      this.fetchOrders();
    },
    async loadMoreKanban() {
      if (this.page.number >= this.page.totalPages - 1) return;
      this.loading = true;
      try {
        const nextPage = this.page.number + 1;
        const params = {
          from: this.filter.from || null,
          to: this.filter.to || null,
          loai: this.filter.loai || null,
          kieuThuong: this.filter.kieuThuong || null,
          trangThai: this.filter.trangThai || null,
          keyword: this.filter.keyword || null,
          page: nextPage,
          size: this.page.size,
        };
        const { data } = await api.get("/api/lenh/admin/list", { params });
        const body = data?.data || {};
        const items = body.content || body.items || [];
        const normalized = items.map(this.normalizeOrder);
        this.orders = [...this.orders, ...normalized];
        this.page.totalPages = body.totalPages || this.page.totalPages;
        this.page.number = body.number ?? nextPage;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    /* ---------- Create ---------- */
    openCreate() {
      this.createForm = {
        tieuDe: "",
        moTa: "",
        loai: "",
        kieuThuong: "",
        batDau: "",
        ketThuc: "",
        tienCong: null,
        tinhThuongQuanLy: true,
        hoTroXangXe: null,
        hoTroCom: null,
        hoTroXangKieu: "PER_DAY",
        hoTroComKieu: "PER_DAY",
        thuongLenhKieu: "PER_DAY",
        selectedUsers: [],
        selectedPhongBans: [],
      };
      this.createFilter = { phongBanId: null };
      this.loadUsersForCreate();
      $("#modalCreate").modal("show");
    },
    onLoaiChange() {
      const loai = this.createForm.loai;
      if (loai === "TANG_CA") {
        this.createForm.kieuThuong = "HOURLY";
      } else if (loai === "CHU_NHAT") {
        this.createForm.kieuThuong = "DAILY";
      } else if (loai === "DIEU_DONG") {
        this.createForm.kieuThuong = "DAILY";
        if (this.createForm.tienCong == null) this.createForm.tienCong = 0;
      }
    },
    validateCreate() {
      const f = this.createForm;
      if (!f.tieuDe || !f.loai || !f.batDau) {
        Swal.fire({ icon: "warning", title: "Thiếu thông tin", text: "Vui lòng nhập tiêu đề, loại lệnh và thời gian bắt đầu." });
        return false;
      }
      if (!f.kieuThuong) {
        Swal.fire({ icon: "warning", title: "Thiếu kiểu thưởng", text: "Vui lòng chọn kiểu thưởng." });
        return false;
      }

      if (f.batDau && f.ketThuc && new Date(f.batDau) >= new Date(f.ketThuc)) {
        Swal.fire({ icon: "warning", title: "Thời gian không hợp lệ", text: "Thời gian kết thúc phải sau thời gian bắt đầu." });
        return false;
      }

      if (f.loai === "TANG_CA") {
        if (f.kieuThuong !== "HOURLY") {
          Swal.fire({ icon: "warning", title: "Sai cấu hình", text: "Lệnh Tăng ca bắt buộc kiểu thưởng Ngoài ca (giờ ca)." });
          return false;
        }
        if (!f.ketThuc) {
          Swal.fire({ icon: "warning", title: "Thiếu thời gian kết thúc", text: "Lệnh theo giờ cần nhập thời gian kết thúc." });
          return false;
        }
        if (!f.tienCong || Number(f.tienCong) <= 0) {
          Swal.fire({ icon: "warning", title: "Thiếu đơn giá", text: "Tăng ca nên có đơn giá tham chiếu > 0." });
          return false;
        }
      } else if (f.loai === "CHU_NHAT") {
        if (f.kieuThuong !== "DAILY") {
          Swal.fire({ icon: "warning", title: "Sai cấu hình", text: "Lệnh Chủ nhật bắt buộc kiểu thưởng Theo ngày (ca HC)." });
          return false;
        }
        if (!f.tienCong || Number(f.tienCong) <= 0) {
          Swal.fire({ icon: "warning", title: "Thiếu đơn giá", text: "Chủ nhật phải có đơn giá/ngày > 0." });
          return false;
        }
      } else if (f.loai === "DIEU_DONG") {
        if (f.kieuThuong !== "DAILY") {
          Swal.fire({ icon: "warning", title: "Sai cấu hình", text: "Lệnh Điều động bắt buộc kiểu thưởng Theo ngày." });
          return false;
        }
        // Đơn giá có thể để 0, không bắt buộc
      }

      return true;
    },
    async loadUsersForCreate() {
      try {
        let list = [];
        if (this.createFilter.phongBanId) {
          const pb = (this.phongBans || []).find(
            (p) => (p.idPhongBan || p.id) === this.createFilter.phongBanId
          );
          const code = pb?.maPhongBan || pb?.code;
          if (code) {
            const { data } = await api.get(`/api/nguoi-dung/by-phong-ban-code/${code}`);
            list = data || [];
          }
        } else {
          const params = { keyword: "", page: 0, size: 1000 };
          const { data } = await api.get("/api/nguoi-dung", { params });
          const body = data?.data || {};
          list = body.content || body.items || [];
        }
        this.usersForCreate = (list || []).map((u) => ({
          idNguoiDung: u.idNguoiDung || u.id,
          tenDangNhap: u.tenDangNhap,
          hoTen: u.hoTen,
          tenPhongBan: u.tenPhongBan || u.phongBan?.tenPhongBan,
          __label: (u.hoTen || u.tenDangNhap) + (u.tenPhongBan ? ` — ${u.tenPhongBan}` : ""),
        }));
      } catch (e) {
        console.error(e);
        this.usersForCreate = [];
      }
    },
    async submitCreate() {
      if (!this.validateCreate()) return;
      this.creating = true;
      try {
        let tienCong = this.createForm.tienCong;
        if (this.createForm.loai === "DIEU_DONG" && (tienCong == null || tienCong === "")) {
          tienCong = 0;
        }

        const payload = {
          tieuDe: this.createForm.tieuDe,
          moTa: this.createForm.moTa || null,
          loai: this.createForm.loai,
          kieuThuong: this.createForm.kieuThuong,
          batDau: this.createForm.batDau,
          ketThuc: this.createForm.ketThuc || null,
          tienCong: tienCong,
          tinhThuongQuanLy: this.createForm.tinhThuongQuanLy,
          hoTroXangXe: this.createForm.loai === "DIEU_DONG" ? (this.createForm.hoTroXangXe || null) : null,
          hoTroCom: this.createForm.loai === "DIEU_DONG" ? (this.createForm.hoTroCom || null) : null,
          hoTroXangKieu: this.createForm.hoTroXangKieu,
          hoTroComKieu: this.createForm.hoTroComKieu,
          thuongLenhKieu: this.createForm.thuongLenhKieu,
        };
        const { data } = await api.post("/api/lenh", payload);
        const created = data?.data || {};
        const idLenh = created.idLenh || created.id;

        const selectedUsers = this.createForm.selectedUsers || [];
        const selectedPhongBans = this.createForm.selectedPhongBans || [];

        if (idLenh) {
          // Gán theo từng nhân viên
          if (selectedUsers.length > 0) {
            const ids = selectedUsers.map((u) => u.idNguoiDung);
            await api.post(`/api/lenh/${idLenh}/assign`, ids);
          }

          // Gán theo phòng ban (tự động gán toàn bộ NV đang hoạt động)
          if (selectedPhongBans.length > 0) {
            const calls = selectedPhongBans
              .map((pb) => pb.idPhongBan || pb.id)
              .filter((phongBanId) => phongBanId != null)
              .map((phongBanId) =>
                api.post(`/api/lenh/${idLenh}/assign-by-phong-ban`, null, {
                  params: { phongBanId },
                })
              );
            await Promise.all(calls);
          }
        }

        $("#modalCreate").modal("hide");
        this.fetchOrders();

        let msg = "Đã tạo lệnh";
        if (selectedUsers.length > 0 && selectedPhongBans.length > 0) {
          msg = "Đã tạo lệnh, gán nhân viên & phòng ban";
        } else if (selectedUsers.length > 0) {
          msg = "Đã tạo lệnh & gán nhân viên";
        } else if (selectedPhongBans.length > 0) {
          msg = "Đã tạo lệnh & gán phòng ban";
        }

        Swal.fire({ icon: "success", title: msg });
      } catch (e) {
        console.error(e);
        Swal.fire({ icon: "error", title: "Tạo lệnh thất bại", text: e?.response?.data?.message || "Có lỗi xảy ra" });
      } finally {
        this.creating = false;
      }
    },

    /* ---------- Assign ---------- */
    openAssign(order) {
      if (!this.canAssign(order)) return;
      this.assignCtx.order = order;
      this.assignCtx.selectedUsers = [];
      this.assignFilter.phongBanId = null;
      this.loadUsers();
      $("#modalAssign").modal("show");
    },
    async fetchPhongBan() {
      try {
        const rs = await api.get("/api/phong-ban/options");
        const raw = rs?.data?.data || rs?.data || [];
        this.phongBans = (raw || []).map(pb => ({
          ...pb,
          idPhongBan: pb.idPhongBan || pb.id,
          __label: pb.tenPhongBan || pb.name || `PB #${pb.idPhongBan || pb.id}`,
        }));
      } catch {
        this.phongBans = [];
      }
    },
    async loadUsers() {
      try {
        let list = [];
        if (this.assignFilter.phongBanId) {
          const pb = (this.phongBans || []).find(
            (p) => (p.idPhongBan || p.id) === this.assignFilter.phongBanId
          );
          const code = pb?.maPhongBan || pb?.code;
          if (code) {
            const { data } = await api.get(`/api/nguoi-dung/by-phong-ban-code/${code}`);
            list = data || [];
          }
        } else {
          const params = { keyword: "", page: 0, size: 1000 };
          const { data } = await api.get("/api/nguoi-dung", { params });
          const body = data?.data || {};
          list = body.content || body.items || [];
        }
        this.users = (list || []).map((u) => ({
          idNguoiDung: u.idNguoiDung || u.id,
          tenDangNhap: u.tenDangNhap,
          hoTen: u.hoTen,
          tenPhongBan: u.tenPhongBan || u.phongBan?.tenPhongBan,
          __label: (u.hoTen || u.tenDangNhap) + (u.tenPhongBan ? ` — ${u.tenPhongBan}` : ""),
        }));
      } catch (e) {
        console.error(e);
        this.users = [];
      }
    },
    async submitAssign() {
      if (!this.assignCtx.order?.idLenh || (this.assignCtx.selectedUsers || []).length === 0) return;
      this.assigning = true;
      try {
        const ids = this.assignCtx.selectedUsers.map((u) => u.idNguoiDung);
        await api.post(`/api/lenh/${this.assignCtx.order.idLenh}/assign`, ids);
        $("#modalAssign").modal("hide");
        Swal.fire({ icon: "success", title: "Đã gán nhân viên" });
        this.fetchOrders();
        if (this.detail.data?.lenh?.idLenh === this.assignCtx.order.idLenh) this.reloadDetail();
      } catch (e) {
        console.error(e);
        Swal.fire({ icon: "error", title: "Gán nhân viên thất bại", text: e?.response?.data?.message || "Có lỗi xảy ra" });
      } finally {
        this.assigning = false;
      }
    },
    async submitAssignDept() {
      if (!this.assignCtx.order?.idLenh || !this.assignFilter.phongBanId) return;
      const pb = (this.phongBans || []).find(
        (p) => (p.idPhongBan || p.id) === this.assignFilter.phongBanId
      );
      const name = pb?.tenPhongBan || "phòng ban đã chọn";

      const ok = await Swal.fire({
        icon: "question",
        title: "Gán cả phòng ban?",
        text: `Hệ thống sẽ gán tất cả nhân viên đang hoạt động trong ${name} vào lệnh này.`,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
      }).then((r) => r.isConfirmed);

      if (!ok) return;

      this.assigningDept = true;
      try {
        await api.post(`/api/lenh/${this.assignCtx.order.idLenh}/assign-by-phong-ban`, null, {
          params: { phongBanId: this.assignFilter.phongBanId },
        });
        Swal.fire({ icon: "success", title: `Đã gán cả ${name}` });
        this.fetchOrders();
        if (this.detail.data?.lenh?.idLenh === this.assignCtx.order.idLenh) {
          this.reloadDetail();
        }
      } catch (e) {
        console.error(e);
        Swal.fire({
          icon: "error",
          title: "Gán phòng ban thất bại",
          text: e?.response?.data?.message || "Có lỗi xảy ra",
        });
      } finally {
        this.assigningDept = false;
      }
    },

    /* ---------- Manager Checkout ---------- */
    async openManagerCheckout(order) {
      if (!this.canManagerCheckout(order)) return;
      this.mCheckout = { order, options: [], selectedUsers: [] };
      await this.fetchDetail(order.idLenh, true);
      const assigns = this.detail.data?.assignments || [];
      const cham = this.detail.data?.chamCongList || [];
      const canClose = assigns
        .filter((a) => a.status === "ACCEPTED")
        .map((a) => {
          const c = cham.find((x) => x.userId === a.userId);
          return { a, c };
        })
        .filter((x) => x.c && x.c.gioVao && !x.c.gioRa)
        .map((x) => ({
          idNguoiDung: x.a.userId,
          hoTen: x.a.hoTen,
          tenDangNhap: x.a.tenDangNhap,
          tenPhongBan: x.a.tenPhongBan,
          __label: (x.a.hoTen || x.a.tenDangNhap) + (x.a.tenPhongBan ? ` — ${x.a.tenPhongBan}` : ""),
        }));
      this.mCheckout.options = canClose;
      $("#modalManagerCheckout").modal("show");
    },
    async submitManagerCheckout() {
      if (!this.mCheckout.order?.idLenh || (this.mCheckout.selectedUsers || []).length === 0) return;
      this.managerClosing = true;
      try {
        const ids = this.mCheckout.selectedUsers.map((u) => u.idNguoiDung);
        await api.post(`/api/lenh/${this.mCheckout.order.idLenh}/manager-checkout`, ids);
        $("#modalManagerCheckout").modal("hide");
        Swal.fire({ icon: "success", title: "Đã đóng ca cho nhân viên được chọn" });
        this.fetchOrders();
        if (this.detail.data?.lenh?.idLenh === this.mCheckout.order.idLenh) this.reloadDetail();
      } catch (e) {
        console.error(e);
        Swal.fire({ icon: "error", title: "Đóng ca thất bại", text: e?.response?.data?.message || "Có lỗi xảy ra" });
      } finally {
        this.managerClosing = false;
      }
    },

    /* ===== CAMERA FULLSCREEN ===== */
    async openStart(order) {
      this.camera = {
        open: true,
        stream: null,
        for: 'start',
        order: order,
        loading: false,
        devices: [],
        deviceIndex: 0,
        lastFacing: 'environment',
        deviceLabel: '',
        geo: { ready:false, lat:null, lng:null, address:'' },
        step: 'live',
        previewUrl: null,
        blob: null,
        captured: false
      };
      await this.prepareCamera();
    },

    async openEnd(order) {
      this.camera = {
        open: true,
        stream: null,
        for: 'end',
        order: order,
        loading: false,
        devices: [],
        deviceIndex: 0,
        lastFacing: 'environment',
        deviceLabel: '',
        geo: { ready:false, lat:null, lng:null, address:'' },
        step: 'live',
        previewUrl: null,
        blob: null,
        captured: false
      };
      await this.prepareCamera();
    },

    async prepareCamera() {
      try {
        if (!navigator.mediaDevices?.getUserMedia) throw new Error("Thiếu API camera");
        this.camera.loading = true;
        this.camera.deviceLabel = '';
        this.prepareGeo();
        this.camera.step = 'live';
        this.camera.previewUrl = null;
        this.camera.blob = null;
        this.camera.captured = false;

        await this.startStreamByFacing(this.camera.lastFacing);
        await this.initDevices(this.camera.lastFacing);

        this.$nextTick(() => this.enterFullscreen());
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Không mở được camera', text: 'Vui lòng cấp quyền camera (HTTPS) và thử lại.' });
        this.stopCamera();
      } finally {
        this.camera.loading = false;
      }
    },

    async initDevices(preferFacing='environment') {
      try {
        const devs = await navigator.mediaDevices.enumerateDevices();
        const videos = devs.filter(d => d.kind === 'videoinput');
        this.camera.devices = videos;

        let idx = 0;
        if (videos.length > 1) {
          const backIdx  = videos.findIndex(d => /back|rear|environment/i.test(d.label));
          const frontIdx = videos.findIndex(d => /front|user|face|webcam/i.test(d.label));
          if (preferFacing === 'environment' && backIdx >= 0) idx = backIdx;
          else if (preferFacing === 'user' && frontIdx >= 0) idx = frontIdx;
        }
        this.camera.deviceIndex = idx;
        this.camera.deviceLabel = videos[idx]?.label || '';
      } catch {
        this.camera.devices = [];
        this.camera.deviceLabel = '';
      }
    },

    async startStreamByFacing(facing='environment') {
      await this.startStream({
        video: { facingMode: { ideal: facing }, width: { ideal: 1920 }, height: { ideal: 1080 } },
        audio: false
      });
    },

    async startStreamByDeviceId(deviceId) {
      await this.startStream({
        video: { deviceId: { exact: deviceId }, width: { ideal: 1920 }, height: { ideal: 1080 } },
        audio: false
      });
    },

    async startStream(constraints) {
      this.stopCameraStreamOnly();
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.camera.stream = stream;
      this.$nextTick(async () => {
        const video = this.$refs.videoRef;
        if (video) {
          video.srcObject = stream;
          await video.play().catch(()=>{});
        }
      });
    },

    async switchCamera() {
      try {
        this.camera.loading = true;
        if (this.camera.step !== 'live') return;
        const vs = this.camera.devices;
        if (vs.length > 1) {
          this.camera.deviceIndex = (this.camera.deviceIndex + 1) % vs.length;
          const dev = vs[this.camera.deviceIndex];
          this.camera.deviceLabel = dev?.label || '';
          await this.startStreamByDeviceId(dev.deviceId);
        } else {
          this.camera.lastFacing = this.camera.lastFacing === 'user' ? 'environment' : 'user';
          await this.startStreamByFacing(this.camera.lastFacing);
        }
      } finally {
        this.camera.loading = false;
      }
    },

    stopCameraStreamOnly() {
      try {
        if (this.camera.stream) this.camera.stream.getTracks().forEach(t => t.stop());
      } catch {}
      this.camera.stream = null;
    },

    enterFullscreen() {
      try {
        const el = this.$refs.cameraModalRef;
        if (el && el.requestFullscreen) el.requestFullscreen().catch(()=>{});
      } catch {}
    },

    exitFullscreen() {
      try {
        if (document.fullscreenElement && document.exitFullscreen) {
          document.exitFullscreen().catch(()=>{});
        }
      } catch {}
    },

    stopCamera() {
      this.exitFullscreen();
      this.stopCameraStreamOnly();
      if (this.camera.previewUrl) URL.revokeObjectURL(this.camera.previewUrl);
      this.camera.open = false;
      this.camera.for = null;
      this.camera.order = null;
      this.camera.devices = [];
      this.camera.deviceLabel = '';
      this.camera.geo = { ready:false, lat:null, lng:null, address:'' };
      this.camera.step = 'live';
      this.camera.previewUrl = null;
      this.camera.blob = null;
      this.camera.captured = false;
    },

    closeCamera() {
      this.stopCamera();
    },

    async capture() {
      try {
        const video = this.$refs.videoRef, canvas = this.$refs.canvasRef;
        if (!video || !canvas) throw new Error("Thiếu phần tử camera");

        for (let i=0;i<10 && (!video.videoWidth || !video.videoHeight);i++) {
          await new Promise(r=>setTimeout(r,120));
        }

        const w = video.videoWidth || 1920, h = video.videoHeight || 1080;
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, w, h);

        const { lat, lng, address } = await this.getGeoReady();
        await this.drawWatermarkLikeSample(ctx, w, h, {
          logo: this._wmLogo,
          when: new Date(),
          address: address || (lat!=null && lng!=null ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : "")
        });

        const blob = await new Promise(res => canvas.toBlob(res, "image/jpeg", 0.92));
        if (!blob) throw new Error("Không chụp được ảnh");
        if (this.camera.previewUrl) URL.revokeObjectURL(this.camera.previewUrl);
        this.camera.blob = blob;
        this.camera.previewUrl = URL.createObjectURL(blob);
        this.camera.step = 'confirm';
        this.camera.captured = true;
      } catch (e) {
        Swal.fire({ icon:'error', title:'Chụp thất bại', text: e?.message || 'Vui lòng thử lại.' });
      }
    },

    retake() {
      if (this.camera.previewUrl) URL.revokeObjectURL(this.camera.previewUrl);
      this.camera.previewUrl = null;
      this.camera.blob = null;
      this.camera.step = 'live';
      this.camera.captured = false;
      this.startStreamByFacing(this.camera.lastFacing);
    },

    prepareGeo() {
      this.camera.geo = { ready:false, lat:null, lng:null, address:'' };
      if (!navigator.geolocation) {
        this.camera.geo.ready = true;
        return;
      }
      navigator.geolocation.getCurrentPosition(async (pos) => {
        const lat = pos.coords.latitude, lng = pos.coords.longitude;
        this.camera.geo.lat = lat;
        this.camera.geo.lng = lng;
        try {
          this.camera.geo.address = await this.reverseGeocode(lat, lng);
        } catch {
          this.camera.geo.address = "";
        }
        this.camera.geo.ready = true;
      }, () => {
        this.camera.geo.ready = true;
      }, { enableHighAccuracy: true, timeout: 12000, maximumAge: 30000 });
    },

    async getGeoReady() {
      if (!this.camera.geo.ready) await new Promise(r => setTimeout(r, 3000));
      return {
        lat: this.camera.geo.lat,
        lng: this.camera.geo.lng,
        address: this.camera.geo.address
      };
    },

    async reverseGeocode(lat, lng) {
      try {
        if (lat == null || lng == null) return null;
        const u = `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lng}&lang=vi&apiKey=${GEOAPIFY_KEY}`;
        const res = await fetch(u);
        const json = await res.json();
        const f = json?.features?.[0];
        return f?.properties?.formatted || `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      } catch {
        return lat && lng ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : null;
      }
    },

    async uploadImageReturnUrl(blob, folderName) {
      const file = new File([blob], `att_${Date.now()}.jpg`, { type: "image/jpeg" });
      const formData = new FormData();
      formData.append("files", file);
      formData.append("folderName", folderName);

      const { data } = await api.post("/api/images/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const fileUrl =
        data?.[0]?.location ||
        data?.data?.[0]?.location ||
        data?.location ||
        data?.data?.location;
      
      if (!fileUrl) throw new Error("Upload ảnh thất bại");
      return fileUrl;
    },

    // Submit START
    async submitStart() {
      if (!this.camera.order?.idLenh) return;
      if (!this.camera.captured || !this.camera.blob) {
        Swal.fire({ icon: "info", title: "Chưa có ảnh", text: "Vui lòng chụp ảnh trước." });
        return;
      }
      if (!this.camera.geo.ready) {
        Swal.fire({ icon: "info", title: "Đang lấy vị trí", text: "Vui lòng chờ..." });
        return;
      }
      this.starting = true;
      try {
        const folder = `lenh-bat-dau`;
        const anhUrl = await this.uploadImageReturnUrl(this.camera.blob, folder);
        const payload = {
          diaDiemText: this.camera.geo.address || null,
          lat: this.camera.geo.lat ?? null,
          lng: this.camera.geo.lng ?? null,
          anhUrl,
        };

        const orderId = this.camera.order?.idLenh;
        await api.post(`/api/lenh/${orderId}/start`, payload);

        this.closeCamera();

        Swal.fire({ icon: "success", title: "Đã bắt đầu lệnh" });
        this.fetchOrders();
        if (orderId && this.detail.data?.lenh?.idLenh === orderId) {
          this.reloadDetail();
        }
      } catch (e) {
        console.error(e);
        Swal.fire({
          icon: "error",
          title: "Bắt đầu lệnh thất bại",
          text: e?.response?.data?.message || e?.message || "Có lỗi xảy ra"
        });
      } finally {
        this.starting = false;
      }
    },

    // Submit END
    async submitEnd() {
      if (!this.camera.order?.idLenh) return;
      if (!this.camera.captured || !this.camera.blob) {
        Swal.fire({ icon: "info", title: "Chưa có ảnh", text: "Vui lòng chụp ảnh trước." });
        return;
      }
      if (!this.camera.geo.ready) {
        Swal.fire({ icon: "info", title: "Đang lấy vị trí", text: "Vui lòng chờ..." });
        return;
      }
      this.ending = true;
      try {
        const folder = `lenh-ket-thuc`;
        const anhUrl = await this.uploadImageReturnUrl(this.camera.blob, folder);
        const payload = {
          diaDiemText: this.camera.geo.address || null,
          lat: this.camera.geo.lat ?? null,
          lng: this.camera.geo.lng ?? null,
          anhUrl,
        };

        const orderId = this.camera.order?.idLenh;
        await api.post(`/api/lenh/${orderId}/end`, payload);

        this.closeCamera();

        Swal.fire({ icon: "success", title: "Đã kết thúc lệnh" });
        this.fetchOrders();
        if (orderId && this.detail.data?.lenh?.idLenh === orderId) {
          this.reloadDetail();
        }
      } catch (e) {
        console.error(e);
        Swal.fire({
          icon: "error",
          title: "Kết thúc lệnh thất bại",
          text: e?.response?.data?.message || e?.message || "Có lỗi xảy ra"
        });
      } finally {
        this.ending = false;
      }
    },

    /* ===== Watermark helpers ===== */
    async drawWatermarkLikeSample(ctx, w, h, opts = {}) {
      const logo = opts.logo || null;
      const when = opts.when instanceof Date ? opts.when : new Date();
      const addr = (opts.address || "").toString();

      const base = Math.max(w, h);
      const pad  = Math.max(12, Math.round(base * 0.012));
      const timeFontPx = Math.max(44, Math.round(base * 0.05));
      const dateFontPx = Math.max(18, Math.round(base * 0.02));
      const addrFontPx = Math.max(14, Math.round(base * 0.017));
      const logoSize   = Math.max(64, Math.round(base * 0.08));

      const extraAddr = addr ? addrFontPx + Math.round(pad * 0.2) : 0;
      const textTotalH = timeFontPx + dateFontPx + dateFontPx + extraAddr;
      const groupH = Math.max(logoSize, textTotalH);

      const top  = h - pad - groupH;
      const left = pad;

      if (logo && (logo.complete || logo.decode)) {
        try {
          if (logo.decode) await logo.decode();
        } catch {}
        const lx = left;
        const ly = top + Math.round((groupH - logoSize) / 2);
        ctx.save();
        this._roundedRect(ctx, lx, ly, logoSize, logoSize, 10);
        ctx.clip();
        ctx.drawImage(logo, lx, ly, logoSize, logoSize);
        ctx.restore();
      }

      const tx = left + logoSize + pad;
      let ty   = top;

      const hh = String(when.getHours()).padStart(2,"0");
      const mm = String(when.getMinutes()).padStart(2,"0");
      const vn = this._formatVnDate(when);

      ctx.save();
      ctx.fillStyle = "#fff";
      ctx.textBaseline = "top";
      ctx.shadowColor = "rgba(0,0,0,0.6)";
      ctx.shadowBlur = Math.max(6, Math.round(base * 0.012));
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = Math.max(2, Math.round(base * 0.003));

      ctx.font = `700 ${timeFontPx}px sans-serif`;
      ctx.fillText(`${hh}:${mm}`, tx, ty);
      ty += timeFontPx + Math.round(pad * 0.2);

      ctx.font = `600 ${dateFontPx}px sans-serif`;
      ctx.fillText(vn.dateLine, tx, ty);
      ty += dateFontPx + Math.round(pad * 0.1);

      ctx.font = `500 ${dateFontPx}px sans-serif`;
      ctx.fillText(vn.weekday, tx, ty);
      ty += dateFontPx + Math.round(pad * 0.1);

      if (addr) {
        ctx.font = `400 ${addrFontPx}px sans-serif`;
        ctx.fillText(addr, tx, ty);
      }
      ctx.restore();
    },

    _roundedRect(ctx, x, y, w, h, r) {
      const rr = Math.min(r, w/2, h/2);
      ctx.beginPath();
      ctx.moveTo(x+rr, y);
      ctx.arcTo(x+w, y, x+w, y+h, rr);
      ctx.arcTo(x+w, y+h, x, y+h, rr);
      ctx.arcTo(x, y+h, x, y, rr);
      ctx.arcTo(x, y, x+w, y, rr);
      ctx.closePath();
    },

    _formatVnDate(d) {
      const day = String(d.getDate()).padStart(2,'0');
      const month = d.getMonth()+1;
      const year = d.getFullYear();
      const weekdays = ["Chủ Nhật","Thứ Hai","Thứ Ba","Thứ Tư","Thứ Năm","Thứ Sáu","Thứ Bảy"];
      return {
        dateLine: `${day} Tháng ${month}, ${year}`,
        weekday: weekdays[d.getDay()]
      };
    },

    /* ---------- Detail ---------- */
    openDetail(order) {
      this.detail = { loading: true, data: null };
      $("#modalDetail").modal("show");
      this.fetchDetail(order.idLenh);
    },
    async reloadDetail() {
      if (this.detail.data?.lenh?.idLenh) await this.fetchDetail(this.detail.data.lenh.idLenh);
    },
    async fetchDetail(lenhId, silent = false) {
      try {
        if (!silent) this.detail.loading = true;
        const { data } = await api.get(`/api/lenh/${lenhId}`);
        this.detail.data = data?.data;
      } catch (e) {
        console.error(e);
        this.detail.data = null;
      } finally {
        if (!silent) this.detail.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* BS4 friendly */
.stats-info { background: #fff; padding: 14px; border-radius: 6px; border: 1px solid #eee; }
.stats-info h6 { margin: 0; color: #888; font-size: 13px; }
.stats-info h4 { margin: 6px 0 0; font-weight: 700; }
.font-weight-600 { font-weight: 600; }
.font-weight-700 { font-weight: 700; }
.cursor-pointer { cursor: pointer; }

/* ORDER CARD (Cards Grid) */
.order-card .card-header { background: #fff; border-bottom: 0; }
.order-card .order-title {
  font-weight: 700; line-height: 1.2; max-width: 320px;
  display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;
}
.ellipsis-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.pill { background: #f4f5f7; border-radius: 999px; padding: 2px 10px; margin-bottom: 6px; font-size: 12px; }
.pill-gray { background: #eef1f4; } .pill-green { background: #e6fbef; }
.pill-red { background: #ffefef; } .pill-dark { background: #ececec; }
.empty-card { border: 1px dashed #e5e7eb; border-radius: 8px; }

/* ===== Fullscreen Camera Styles ===== */
.camera-modal--fs {
  position: fixed;
  inset: 0;
  background: #000;
  z-index: 1050;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.camera-box--fs {
  position: relative;
  width: 100vw;
  height: 100vh;
  padding: 0;
  border-radius: 0;
  background: #000;
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

.camera-video--fs,
.confirm-img--fs {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.camera-header--fs {
  position: absolute;
  top: 0;
  left: 0; right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  padding-top: calc(env(safe-area-inset-top) + 8px);
  background: linear-gradient(to bottom, rgba(0,0,0,.45), rgba(0,0,0,0));
  color: #fff;
  z-index: 2;
}

.camera-actions--fs {
  position: absolute;
  left: 0; right: 0;
  bottom: 0;
  padding: 12px 16px calc(env(safe-area-inset-bottom) + 16px);
  background: linear-gradient(to top, rgba(0,0,0,.45), rgba(0,0,0,0));
  z-index: 2;
}

.btn-cta-fs {
  height: 56px;
  font-size: 18px;
  border-radius: 14px;
  box-shadow: 0 8px 18px rgba(0,0,0,.35);
}

.confirm-pane {
  height: 100%;
}

/* Detail cards */
.assign-card, .cc-card {
  border: 1px solid #eee; border-radius: 8px; padding: 8px 10px; margin-bottom: 8px; background: #fff;
}
.thumb { border: 1px solid #eee; border-radius: 8px; overflow: hidden; cursor: zoom-in; }
.thumb img { width: 100%; height: auto; display: block; }
.thumb.xs { width: 100%; max-width: 120px; }
.thumb.xs img { width: 100%; }

/* status badges */
.badge.badge-secondary { background: #6c757d; }
.badge.badge-info { background: #17a2b8; }
.badge.badge-success { background: #28a745; }
.badge.badge-warning { background: #ffc107; color: #212529; }
.badge.badge-danger { background: #dc3545; }
.badge.badge-dark { background: #343a40; }
.badge.badge-light { background: #f8f9fa; color: #212529; }
.badge.badge-primary { background: #007bff; }

/* ====== KANBAN ====== */
.kanban-board {
  display: grid;
  grid-template-columns: repeat(3, minmax(280px, 1fr));
  gap: 14px;
  align-items: start;
}
@media (max-width: 1200px) {
  .kanban-board { grid-template-columns: repeat(2, minmax(280px, 1fr)); }
}
@media (max-width: 768px) {
  .kanban-board { grid-template-columns: repeat(1, minmax(280px, 1fr)); }
}
.kanban-col {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  overflow: hidden;
}
.kanban-col-header {
  padding: 12px 14px;
  color: #fff;
}
.kb-hd-draft {
  background: linear-gradient(135deg, #6c757d, #8b949e);
}
.kb-hd-running {
  background: linear-gradient(135deg, #17a2b8, #20c997);
}
.kb-hd-ended {
  background: linear-gradient(135deg, #28a745, #59c173);
}
.kanban-col-body {
  padding: 10px;
  max-height: 70vh;
  overflow: auto;
}
.kanban-card.card {
  border-radius: 10px;
  border: 1px solid #e9eef5;
  margin-bottom: 10px;
  transition: box-shadow 0.15s ease;
}
.kanban-card.card:hover {
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
}
.kb-title {
  font-weight: 700;
  line-height: 1.2;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}
.kb-pills .pill { padding: 2px 8px; font-size: 11px; }
.btn-xs { padding: 2px 6px; font-size: 11px; line-height: 1.2; border-radius: 6px; }
.kb-empty { text-align: center; padding: 18px 6px; border: 1px dashed #e5e7eb; border-radius: 8px; }

/* Trên mobile nhỏ */
@media (max-width: 576px) {
  .btn-cta-fs { height: 60px; font-size: 17px; }
}
</style>
